// extracted by mini-css-extract-plugin
module.exports = {"legend":"indicator-legend_legend__E8VTX","row":"indicator-legend_row__LDSkB","badge":"indicator-legend_badge__C2KtY","glyph":"indicator-legend_glyph__GpAkp"};